class HelperFunction {
    constructor() {}

    setDataLayerCookiesBanner() {
        
        var dataLayer = window.dataLayer = window.dataLayer || [];
        let allCookies = ['criteo','idealo','billiger','ladenzeile','pinterest','instagram','bing','google','google_tag_manager','hello','cb_fbp','googleAnalytics'];
        allCookies.forEach(function(cookie){
            let dataCookieKey = cookie+"IsCookieSet";
            if (cookie == 'cb_fbp') {
                dataCookieKey = "facebookIsCookieSet";
            }
            if (cookie == 'googleAnalytics') {
                dataCookieKey = "googleAnalyticsIsCookieSet";
            }
            if (Cookies.get(cookie) == 0) {
                dataLayer.push({[dataCookieKey]:true});
            } else {
                dataLayer.push({[dataCookieKey]:false});
            }
        });
    }
    
    trackingEcommerceCheckout() {
    
        if (Shopify && Shopify.checkout_details) {
            
            var dataLayer = window.dataLayer = window.dataLayer || [];
      
            let checkoutEcommerce = {};
            checkoutEcommerce.event = "checkout";
            checkoutEcommerce.ecommerce = {};
            checkoutEcommerce.ecommerce.checkout = {};
            
            let step = 6;
            if (Shopify.Checkout && Shopify.Checkout.step && Shopify.Checkout.step !== "") {
                step = ["contact_information", "shipping_method", "payment_method", "review"].indexOf(Shopify.Checkout.step) + 3 || step;
            }
            checkoutEcommerce.ecommerce.checkout.actionField = { "step": step };
           
            checkoutEcommerce.ecommerce.checkout.products = [];

            if (Shopify.checkout_details.checkoutProducts && Array.isArray(Shopify.checkout_details.checkoutProducts) && Shopify.checkout_details.checkoutProducts.length > 0) {
                
                Shopify.checkout_details.checkoutProducts.forEach(function(prod, key) {
                    let product = {};
            
                    if (prod.name) {
                        product.name = prod.name;
                    }
                    // if (prod.id) {
                    //     product.id = prod.id;
                    // }
                    if (prod.sku) {
                        product.id = prod.sku;
                    }

                    if (prod.price) {
                        product.price = parseFloat(prod.price/100);
                    }

                    if (prod.vendor) {
                        product.brand = prod.vendor;
                    }

                    if (prod.category) {
                        product.category = prod.category;
                    }

                    if (prod.quantity) {
                        product.quantity = prod.quantity;
                    }

                    if (prod.variant && prod.variant.title) {
                        product.variant = prod.variant.title;;

                    }

                    checkoutEcommerce.ecommerce.checkout.products.push(product);

                });
            }

            dataLayer.push({ ecommerce: null });
            dataLayer.push(checkoutEcommerce);
            
        }
    }

    trackingEcommerceCart(cartData, stepData) {
       
         if (cartData) {
            
            var dataLayer = window.dataLayer = window.dataLayer || [];
      
            let checkoutEcommerce = {};
            checkoutEcommerce.event = "checkout";
            checkoutEcommerce.ecommerce = {};
            checkoutEcommerce.ecommerce.checkout = {};
            
            let step = 1;
            if (Number.isInteger(stepData)) {
                step = stepData;
            }
            checkoutEcommerce.ecommerce.checkout.actionField = { "step": step };
           
            checkoutEcommerce.ecommerce.checkout.products = [];

            if (cartData.items && Array.isArray(cartData.items) && cartData.items.length > 0) {
                
                cartData.items.forEach(function(prod, key) {
                    let product = {};
            
                    if (prod.name) {
                        product.name = prod.product_title;
                    }

                    // if (prod.id) {
                    //     product.id = prod.product_id;
                    // }
                    if (prod.sku) {
                        product.id = prod.sku;
                    }

                    if (prod.price) {
                        product.price = parseFloat(prod.price/100);
                    }

                    if (prod.vendor) {
                        product.brand = prod.vendor;
                    }

                    if (prod.category) {
                        product.category = prod.product_type;
                    }

                    if (prod.quantity) {
                        product.quantity = prod.quantity;
                    }

                    if (prod.variant && prod.variant.title) {
                        product.variant = prod.variant.title;;

                    }

                    checkoutEcommerce.ecommerce.checkout.products.push(product);

                });
            }
             
            if (cartData.currency) {
                checkoutEcommerce.ecommerce.checkout.currencyCode = cartData.currency;
            }
            
            dataLayer.push({ ecommerce: null });
            dataLayer.push(checkoutEcommerce);
            
        }

    }

    trackingEcommercePurchase() {
    
        if (Shopify && Shopify.checkout_details && Shopify.checkout) {
            
            var dataLayer = window.dataLayer = window.dataLayer || [];
      
            let checkoutEcommerce = {};
            checkoutEcommerce.ecommerce = {};
            checkoutEcommerce.ecommerce.purchase = {};
            
            checkoutEcommerce.ecommerce.purchase.actionField = {};
           
            if (Shopify.orderNumber) {
                checkoutEcommerce.ecommerce.purchase.actionField.id = Shopify.orderNumber
            }

            checkoutEcommerce.ecommerce.purchase.actionField.affiliation = 'Online Store';
            
            if (Shopify.checkout.total_price) {
                checkoutEcommerce.ecommerce.purchase.actionField.revenue = Shopify.checkout.total_price;
            }

            if (Shopify.checkout.total_tax) {
                checkoutEcommerce.ecommerce.purchase.actionField.tax = Shopify.checkout.total_tax;
            }

            if (Shopify.checkout.shipping_rate && Shopify.checkout.shipping_rate.price && Shopify.checkout.shipping_rate.price !== "") {
                checkoutEcommerce.ecommerce.purchase.actionField.shipping = Shopify.checkout.shipping_rate.price;
            }

            if (Shopify.checkout.discount && Shopify.checkout.discount.code && Shopify.checkout.discount.code !== "") {
                checkoutEcommerce.ecommerce.purchase.actionField.coupon = Shopify.checkout.discount.code;
            }


            checkoutEcommerce.ecommerce.purchase.products = [];

            if (Shopify.checkout_details.checkoutProducts && Array.isArray(Shopify.checkout_details.checkoutProducts) && Shopify.checkout_details.checkoutProducts.length > 0) {
                
                Shopify.checkout_details.checkoutProducts.forEach(function(prod, key) {
                    let product = {};
            
                    if (prod.name) {
                        product.name = prod.name;
                    }

                    // if (prod.id) {
                    //     product.id = prod.id;
                    // }
                    if (prod.sku) {
                        product.id = prod.sku;
                    }

                    if (prod.price) {
                        product.price = parseFloat(prod.price/100);
                    }

                    if (prod.vendor) {
                        product.brand = prod.vendor;
                    }

                    if (prod.category) {
                        product.category = prod.category;
                    }

                    if (prod.quantity) {
                        product.quantity = prod.quantity;
                    }

                    if (prod.variant && prod.variant.title) {
                        product.variant = prod.variant.title;;

                    }

                    checkoutEcommerce.ecommerce.purchase.products.push(product);

                });
            }

            dataLayer.push({ ecommerce: null });
            dataLayer.push(checkoutEcommerce);
            
        }
    }
      
}